import axios from "axios";

import { Env } from "./env";
import { getAccessToken, showAlert } from "../utils";

export const API_URL = Env.BASE_URL;
export const apiErrorCode = {
  INVALID_TOKEN: 419,
  ACCOUNT_BLOCKED: 423,
  ACCESS_DENIED: 430,
  SESSION_EXPIRED: 401,
  INTERNAL_ERROR: 500,
  NOT_AUTHORIZED: 403,
  USER_BLOCKED: 401,
  ACCESS_UPDATED: 405,
  DATA_NOT_FOUND: 404,
};

export const apiSuccessCode = {
  success: 200,
  ok: 202,
  postApiSuccess: 201,
};

export const getTimezone = () => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return tz === "Asia/Calcutta" ? "Asia/Kolkata" : tz;
};

export const $axios = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    platform: 1,
    "accept-language": "en",
    "X-API-Key": Env.API_KEY,
    accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    timezone: getTimezone(),
    offset: Math.abs(new Date().getTimezoneOffset() * 60 * 1000),
  },
});

export const $axios1 = axios.create({
  headers: {
    platform: 1,
    "accept-language": "en",
    "X-API-Key": Env.API_KEY,
    accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    timezone: getTimezone(),
    offset: Math.abs(new Date().getTimezoneOffset() * 60 * 1000),
  },
});

$axios.interceptors.request.use(
  (config: any) => {
    const dynamicJwtToken = getAccessToken();

    if (dynamicJwtToken) {
      config.headers["Authorization"] = `Bearer ${dynamicJwtToken}`;
    } else if (config.headers) {
      delete config.headers["Authorization"];
    }
    return config;
  },

  (error: any) => {
    return Promise.reject(error);
  },
);

$axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      (error.config.method === "post" ||
        error.config.method === "put" ||
        error.config.method === "patch" ||
        error.config.method === "delete") &&
      error.response.status === apiErrorCode.NOT_AUTHORIZED &&
      error.response.data.statusCode === apiErrorCode.NOT_AUTHORIZED
    ) {
      showAlert(5, error?.response?.data?.message);
    }
    return Promise.reject(error);
  },
);
